import React from 'react';

const LoadingSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    width="100"
    height="100"
    style={{ shapeRendering: 'auto', display: 'block', background: 'rgb(255, 255, 255)' }}
  >
    <g>
      <g transform="translate(50 50)">
        <g transform="scale(0.7)">
          <g transform="translate(-50 -50)">
            <g>
              <animateTransform
                dur="0.7575757575757576s"
                keyTimes="0;1"
                values="0 50 50;360 50 50"
                repeatCount="indefinite"
                type="rotate"
                attributeName="transform"
              />
              <path d="M50 50L50 0A50 50 0 0 1 100 50Z" fill="#b55232" fillOpacity="0.8" />
            </g>
            <g>
              <animateTransform
                dur="1.0101010101010102s"
                keyTimes="0;1"
                values="0 50 50;360 50 50"
                repeatCount="indefinite"
                type="rotate"
                attributeName="transform"
              />
              <path transform="rotate(90 50 50)" d="M50 50L50 0A50 50 0 0 1 100 50Z" fill="#ed7c31" fillOpacity="0.8" />
            </g>
            <g>
              <animateTransform
                dur="1.5151515151515151s"
                keyTimes="0;1"
                values="0 50 50;360 50 50"
                repeatCount="indefinite"
                type="rotate"
                attributeName="transform"
              />
              <path transform="rotate(180 50 50)" d="M50 50L50 0A50 50 0 0 1 100 50Z" fill="#f69220" fillOpacity="0.8" />
            </g>
            <g>
              <animateTransform
                dur="3.0303030303030303s"
                keyTimes="0;1"
                values="0 50 50;360 50 50"
                repeatCount="indefinite"
                type="rotate"
                attributeName="transform"
              />
              <path transform="rotate(270 50 50)" d="M50 50L50 0A50 50 0 0 1 100 50Z" fill="#0f8690" fillOpacity="0.8" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default LoadingSVG;
